import React, { Component } from "react";
import services from "../../../services";
import $ from "jquery";
import TlkTable from "../../../components/tlelrik/table/tlkTable";
import RightPopModalForm from "../../../components/common/RightPopModalForm";
import Deltalhes from "../selos/AffixingPopup/Deltalhes";


const queryString = require("query-string");
var moment = require("moment");
const dateFormat = "YYYY-MM-DD";
let listdefaultRequest = {
    Filters: null,
    SortBy: "",
    IsSortTypeDESC: true,
    IsPagination: true,
    Page: 1,
    PageSize: 100,
};
let today = new Date();
let current_date = moment(today).format(dateFormat);
today.setDate(today.getDate() - 7);
let LastWeek = moment(today).format(dateFormat);

today = new Date();
today.setDate(today.getDate() - 14);
let Last2Week = moment(LastWeek).format(dateFormat);

today = new Date();
today.setMonth(today.getMonth() - 1);
let Pastmonthdate = moment(today).format(dateFormat);

let tablesjson = {
    Instalações: {
        columnkeyMap: {
            localArmazenagem: "Local de Armazenagem",
            instalacaoVinica: "Instalação Vínica",
            franquia: "Franquia",
            saldoGranel: "Granel Não Certificado",
            saldoGranelApto: "Granel Apto",
            saldoIndispGranel: "Indisp a Granel",
            saldoIndispEngarrafado: "Indisp Engarrafado",
            saldoProdutoAcabado: "Produto Acabado",
            estado: "Estado",
            geocodigo: "Geocódigo",
            // codigoIVV: "Nº SIVV",
            // código_de_Instalação: "Código"
            //localArmazenagem: "Local de Armazenagem",
            //instalacaoVinica: "Designação",
            //morada: "Morada",
            //lugar: "Lugar",
            //tipoInstalacao: "Tipo de Instalação",
            //franquia: "Franquia",
            //geocodigo: "Geocódigo",
            //fregusianame: "Freguesia",
            //Codigo_Entreposto_fiscal: "Codigo Entreposto Fiscal",
            // geocodigo: "Geocódigo",
            // tipo_de_Instalação: "Tipo instalação",
            //"Sit. IVV": "Sit. IVV",

            
            //ano: "Ano",
            //estado: "Estado",
            // Codigo_entreposto_fiscal: "Codigo Entreposto fiscal",
        },
        actionbuttons: { Edit: true }, // Redirect: "Emitir Fatura",
        listApilink: "/SIVDP/P_instalacao_vinica_listinstalationsbyname",
        requestMethod: "post",
        notAction: false,
        deleteAPILink: "/BusEntidadeEstatuto/Delete/",
        Filters: {
            NumInstalacao: null,
            Designacao: null,
            TipoInstalacao: null,
            Estado: null,
            nome: null,
            numero: null,
            DataCriadoStart: null,
            DataCriadoEnd: null,
            DataModificadoStart: null,
            DataModificadoEnd: null,
            Geocod: null,
            Concelho: null,
            NomeEntreposto: null,
            Distrito: null,
            Fregusia: null,
            codEntidade: null,
            //Alteração MM
            franquia: null,
            saldoGranel: null,
            saldoGranelApto: null,
            saldoIndispGranel: null,
            saldoIndispEngarrafado: null,
            saldoProdutoAcabado: null
        },
        // groupfield: [{ field: 'Tipo receita' } ]
    },
    Instalações_Vasilhas: {
        columnkeyMap: {
            tipoVasilha: "Tipo de Vasilha",
            numeroVasilha: "Número",
            //Armazém: "Armazém",
            capacidadeComunicada: "Cap Comunicada (L)",
            capacidadeAferida: "Cap Aferida (L)",
            // ownerName: "Proprietário",
        },
        actionbuttons: { instalacaoEdit: "Editar", removeVasilha: "Remover" }, // Redirect: "Emitir Fatura",
        //https://localhost:44397/api/InstalacaoVinica/GetVasilhas
        listApilink: "InstalacaoVinica/GetVasilhas",
        requestMethod: "post",
        notAction: false,
        deleteAPILink: "/BusEntidadeEstatuto/Delete/",
        Filters: {
            // start_date: null,
            // end_date: null,
            // entity_id: null,
            //idInstalacaoVinica: "",
        },
        Importarbutton: true,
        // groupfield: [{ field: 'Tipo receita' } ]
    },
};

class InstalaCaovinicaTables extends Component {
    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = {
            linkData: tablesjson[this.props.tableName],
            telkikTable: null,
            popUpForm: null,
            tlkState: null,
            totalcount: 0,
            showSearchMsg: false,
        };
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount = () => {
        //this.defaultState();
        console.log("the mount of the table");
    };

    /* Esta função irá chamar automaticamente quando o estado da página mudar  */
    componentDidUpdate = (preProp) => {
        // console.log("DATE",preProp.date,this.props.date);
        if (
            preProp.date !== this.props.date ||
            preProp.tableName !== this.props.tableName ||
            preProp.idInstalacaoVinica != this.props.idInstalacaoVinica
        ) {
            this.defaultState();
        }
        if (preProp.showSearchMsg !== this.props.showSearchMsg) {
            this.setState({
                showSearchMsg: this.props.showSearchMsg,
                totalcount: 0,
                telkikTable: null,
            });
        }
        // if(JSON.stringify(preProp.idInstalacaoVinica) !== JSON.stringify(this.props.idInstalacaoVinica)) {
        //     this.setState({
        //         idInstalacaoVinica: this.props.idInstalacaoVinica
        //     }, () => {
        //         this.getListData()
        //     })
        // }
        if (preProp.allVasilha && this.props.allVasilha) {
            if (preProp.allVasilha.length !== this.props.allVasilha.length) {
                this.defaultState();
            }
        }
    };

    /* Para obter filtros para a API */
    getAllFilter = () => {
        let Request = { ...listdefaultRequest };
        Request.Filters = this.state.linkData.Filters;
        let appliedFilter = { ...this.props.applyedfilter };
        if (appliedFilter) {
            if (appliedFilter["entityIdFilter"]) {
                appliedFilter["NumInstalacao"] =
                    appliedFilter.NumInstalacao = appliedFilter.entityIdFilter
                    
                //     this.props.applyedfilter["Installation"] + "";
                // delete appliedFilter["Installation"];
                // delete appliedFilter["InstallationNo"];
            }
            if (appliedFilter["Installation"]) {
                appliedFilter["NumInstalacao"] =
                    this.props.applyedfilter["Installation"] + "";
                delete appliedFilter["Installation"];
                delete appliedFilter["InstallationNo"];
            }
            if (appliedFilter["Tipo de instalação"]) {
                appliedFilter["TipoInstalacao"] =
                    this.props.applyedfilter["Tipo de instalação"] + "";
                delete appliedFilter["Tipo de instalação"];
            }
            if (appliedFilter["entityType"]) {
                appliedFilter["numero"] =
                    this.props.applyedfilter["entityType"] + "";
                delete appliedFilter["entityType"];
            }
            // if (appliedFilter["Armazém"]) {
            //     appliedFilter["NomeEntreposto"] =
            //         this.props.applyedfilter["Armazém"] + "";
            //     delete appliedFilter["Armazém"];
            // }
            if (appliedFilter["Granel Não Certificado"]) {
                appliedFilter["saldoGranel"] =
                    this.props.appliedFilter["Granel Não Certificado"] + "";//saldoGranel: "Granel Não Certificado",
                delete appliedFilter["Granel Não Certificado"];
                
            }
            if (appliedFilter["Franquia"]) {
                appliedFilter["franquia"] = 
                    this.props.appliedFilter["Franquia"] + "";
                delete appliedFilter["Franquia"];
                
            }
            if (appliedFilter["Granel Apto"]) {
                appliedFilter["saldoGranelApto"] =
                    this.props.appliedFilter["Granel Apto"] + "";//saldoGranelApto: "Granel Apto",
                delete appliedFilter["Granel Apto"];
                
            }
            if (appliedFilter["Indisp a Granel"]) {
                appliedFilter["saldoIndispGranel"] =
                    this.props.appliedFilter["Indisp a Granel"] + "";//saldoIndispGranel: "Indisp a Granel",
                delete appliedFilter["Indisp a Granel"];
                
            }
            if (appliedFilter["Indisp Engarrafado"]) {
                appliedFilter["saldoIndispEngarrafado"] =
                    this.props.appliedFilter["Indisp Engarrafado"] + "";//saldoIndispEngarrafado: "Indisp Engarrafado",
                delete appliedFilter["Indisp Engarrafado"];
                
            }
            if (appliedFilter["Produto Acabado"]) {
                appliedFilter["saldoProdutoAcabado"] =
                    this.props.appliedFilter["Produto Acabado"] + "";//saldoProdutoAcabado: "Produto Acabado",
                delete appliedFilter["Produto Acabado"];
                
            }
            if (appliedFilter["Geocódigo"]) {
                appliedFilter["Geocod"] =
                    this.props.applyedfilter["Geocódigo"] + "";
                delete appliedFilter["Geocódigo"];
            }
        }
        delete appliedFilter["local"];
        console.log("applied", appliedFilter);
        Request.Filters = { ...Request.Filters, ...appliedFilter };
        // console.log("Fileter", Request.Filters);
        // if (Request.Filters.entity_id === undefined) {
        //     Request.Filters.entity_id = null
        // }
        // Request.Filters.local = null // window.localStorage.getItem('Local');
        // if (this.props.tableName === "Faturas" && Request.Filters.entity_id > 0) {
        //     Request.Filters.is_paid = null;
        // }
        return Request;
    };

    /*  Para excluir uma linha da base de dados no servidor */

    handleDelete = async (id) => {
        let link = this.state.linkData.deleteAPILink;
        let res = await services.apiCall.requestApi(
            link + "/" + id,
            {},
            "post"
        );
        if (res) {
            this.defaultState();
        }
    };

    /* Carregar estado de página padrão  */

    defaultState = () => {
        let linkData = { ...tablesjson };
        linkData = tablesjson[this.props.tableName];

        // console.log("linkdata", this.props.tableName, linkData)
        this.setState(
            {
                linkData: linkData,
                telkikTable: null,
                showSearchMsg: false,
                tlkState: {
                    take: 100,
                    skip: 0,
                    group: [],
                    exporting: false,
                },
                idInstalacaoVinica: this.props.idInstalacaoVinica,
            },
            () => this.getListData(),
            () => this.getAllGranel(),
        );
    };

    vasilhaGetAll = () => {
        const queryParams = queryString.parse(window.location.search)
        const cenas = queryParams.idInstalacao
        var request = {"idInstalacaoVinica": cenas}
        // let request = { ...listdefaultRequest };
        // request.Filters = this.state.linkData.Filters;
        // request.Filters.idInstalacaoVinica = +this.props.idInstalacaoVinica;
        return request;
    };


// Carragamento dos dados Granel na grid principal.
    getAllGranel = async () => {
        if (!this.state.linkData) return;
        let Request = this.getAllFilter();
        console.log("reeeeeeeeeeeeeeeeeeeeeeee", Request);
        if (this.state.linkData.singleEntity && !Request.Filters.entity_id)
            return;
        this.setState({
            totalcount: 0,
        });
        var link = this.state.linkData.listApilink;
        var method = this.state.linkData.requestMethod;
        if (this.props.tableName === "Instalações_Vasilhas") {
            console.log("what worked is here ", this.props.idInstalacaoVinica);
            Request = this.vasilhaGetAll();
            link = "InstalacaoVinica/ViewInstalacaoVinicaDetalhe";
            // res = res.vasilhas
            method = "get"
        }
       
        let columnkeyMap = this.state.linkData.columnkeyMap;
        
        let res = await services.apiCall.requestApi(link, Request, method);
        if (this.props.tableName === "Instalações_Vasilhas") {
            res = res.vasilhas
        }
        console.log(
            "waitingg ",
            link,
            Request,
            method,
            this.props.idInstalacaoVinica
        );

        // if (res && Array.isArray(res) && res.length) {
        //     console.log("the response of the vasilha list is, ", res);
        //     let appliedFilter = { ...this.props.applyedfilter };
        //     if (appliedFilter) {
        //         appliedFilter["codEntidade"] =
        //         appliedFilter.codEntidade = res[0].codEntidade
        //         console.log(appliedFilter.codEntidade , "Aqui está a entidade.....")
        //         console.log("Aqui está a entidade.....", appliedFilter);
        //     }
        // }
        //if (!this.state.linkData) return;
        
        // let requestCod = this.granelGetAll();
        console.log("----------->>>>>", res);

        

        const dataToken = {"idEntidade":  res[0].codEntidade}
        const DetalhesGranel = await services.apiCall.requestApi(
            "/InstalacaoVinica/ViewContasCorrentesVinicas",
            dataToken,
                "get"
            );
        let granel = DetalhesGranel;
        let arrayGranel =[];
            // saldoGranelApto: "Granel Apto",
            // saldoIndispGranel: "Indisp a Granel",
            // saldoIndispEngarrafado: "Indisp Engarrafado",
            // saldoProdutoAcabado: "Produto Acabado",

        if(granel.length > 0){
            let appliedFilter = { ...this.props.applyedfilter };
            if (appliedFilter) {
                appliedFilter["codEntidade"] =
                appliedFilter.codEntidade = granel[0].codEntidade
                console.log(appliedFilter.codEntidade , "Aqui está a entidade.....")
                console.log("Aqui está a entidade.....", appliedFilter);
                
            }
            
            granel.map((row, index) => {
                Object.keys(columnkeyMap).map(function (key) {
                    if(row == "franquia"){
                        row[columnkeyMap[key]] = row.franquia;
                    }else if(row == "saldoGranel"){
                        row[columnkeyMap[key]] = row.saldoGranel;
                    }else if(row == "saldoGranelApto"){
                        row[columnkeyMap[key]] = row.saldoGranelApto;
                    }else if(row == "saldoIndispGranel"){
                        row[columnkeyMap[key]] = row.saldoIndispGranel;
                    }else if(row == "saldoIndispEngarrafado"){
                        row[columnkeyMap[key]] = row.saldoIndispEngarrafado;
                    }else if(row == "saldoProdutoAcabado"){
                        row[columnkeyMap[key]] = row.saldoProdutoAcabado;
                    }else{
                        row[columnkeyMap[key]] = row[key];
                    }
                })    
            });
            this.setState(
                {
                    data: granel,
                    filterData: granel,
                    showSearchMsg: false,
                    totalcount: window.localStorage.getItem("TableIV"),
                },
                () => {
                    this.createTabel();
                    if (this.props.modificaoDateShow) {
                        this.props.modificaoDateShow(arrayGranel);
                    }
                }
            );
                } else {
                    this.setState({ showSearchMsg: true }, () => {
                    if (this.props.modificaoDateShow) {
                        this.props.modificaoDateShow([]);
                }
            });
            
        }
    };

    /*Para obter dados para a tabela usando apis */

    getListData = async () => {
        if (!this.state.linkData) return;
        let Request = this.getAllFilter();
        console.log("reeeeeeeeeeeeeeeeeeeeeeee", Request);
        if (this.state.linkData.singleEntity && !Request.Filters.entity_id)
            return;
        this.setState({
            totalcount: 0,
        });
        var link = this.state.linkData.listApilink;
        var method = this.state.linkData.requestMethod;
        if (this.props.tableName === "Instalações_Vasilhas") {
            console.log("what worked is here ", this.props.idInstalacaoVinica);
            Request = this.vasilhaGetAll();
            link = "InstalacaoVinica/ViewInstalacaoVinicaDetalhe";
            // res = res.vasilhas
            method = "get"
        }
       
        let columnkeyMap = this.state.linkData.columnkeyMap;
        
        let res = await services.apiCall.requestApi(link, Request, method);
        if (this.props.tableName === "Instalações_Vasilhas") {
            res = res.vasilhas
        }
        console.log(
            "waitingg ",
            link,
            Request,
            method,
            this.props.idInstalacaoVinica
        );
        let dateArray = [];
        var invoicecode = [];
        if (res.length > 0) {
            console.log("the response of the vasilha list is, ", res);
            let appliedFilter = { ...this.props.applyedfilter };
            if (appliedFilter) {
                appliedFilter["codEntidade"] =
                appliedFilter.codEntidade = res[0].codEntidade
                console.log(appliedFilter.codEntidade , "Aqui está a entidade.....")
                console.log("Aqui está a entidade.....", appliedFilter);
            }

            res.map((_row, index) => {
                if (_row.invoiceHistory) {
                    _row.invoiceHistory.map((_r, i) => {
                        invoicecode = [];
                        if (_r.file_Link && _r.invoiceType) {
                            invoicecode = _r.invoiceType.split("-");
                            if (
                                invoicecode[0] === "IVF" ||
                                invoicecode[0] === "IVP" ||
                                invoicecode[0] === "API"
                            ) {
                                _row.document_url =
                                    "/api/" +
                                    _r.file_Link.replace(
                                        "file:///C:/DevelopmentIVPD",
                                        ""
                                    );
                            } else {
                                _row.invoice_url =
                                    "/api/" +
                                    _r.file_Link.replace(
                                        "file:///C:/DevelopmentIVPD",
                                        ""
                                    );
                            }
                        }
                    });
                }
                if (_row.dataModificado) {
                    dateArray.push(
                        new Date(moment(_row.dataModificado).format(dateFormat))
                    );
                }
                Object.keys(columnkeyMap).map(function (key) {
                    if (key === "n doc") {
                        _row[columnkeyMap[key]] = _row.no;
                    } else if (key === "Entidade") {
                        _row[columnkeyMap[key]] = _row.busEntidade.nome;
                    } else if (key === "entityObject") {
                        _row[columnkeyMap[key]] = _row.entity_id
                            ? _row.entityObject.nome
                            : "";
                    } else if (key === "flag") {
                        _row[columnkeyMap[key]] = _row["flag"];
                    } else if (
                        key === "Invoice_date" ||
                        key === "issue_date_time"
                    ) {
                        _row[columnkeyMap[key]] = moment(
                            _row["issue_date_time"]
                        ).format(dateFormat);
                    } else if (key === "pag_limit") {
                        _row[columnkeyMap[key]] = _row["deadline_date"]
                            ? moment(_row["deadline_date"]).format(dateFormat)
                            : moment(_row["issue_date_time"]).format(
                                  dateFormat
                              );
                    } else if (key === "is_doc_generated") {
                        _row[columnkeyMap[key]] =
                            parseInt(_row["is_doc_generated"]) === 1
                                ? "Sim"
                                : "Não";
                    } else if (key === "Interest_to_date") {
                        _row[columnkeyMap[key]] = services.money.format(
                            _row.service_tax
                        );
                    } else if (key === "Valor c/ IVA") {
                        _row[columnkeyMap[key]] = services.money.format(
                            _row.total_amount
                        );
                    } else if (key === "valor_cativo") {
                        _row[columnkeyMap[key]] = services.money.format(
                            _row.valor_cativo
                        );
                    } else if (key === "Valor IVA") {
                        _row[columnkeyMap[key]] = services.money.format(
                            _row.iva
                        );
                    } else if (key === "add_Amonut_text") {
                        _row[columnkeyMap[key]] =
                            _row.allTransaction && _row.allTransaction[0]
                                ? _row.allTransaction[0].comment
                                : "";
                    } else if (key === "for_invoice_id") {
                        _row[columnkeyMap[key]] = _row.for_invoice_id
                            ? "Pagamento da Fatura"
                            : "Pagamento Antecipado";
                    } else if (key === "is_paid") {
                        _row[columnkeyMap[key]] =
                            _row[key] === 0 ? "Pendente" : "Não Pendente";
                    } else if (key === "Amount_paid") {
                        _row[columnkeyMap[key]] = services.money.format(
                            _row["amount_paid"]
                        );
                    } else if (
                        key === "outgoingAmount" &&
                        _row["document_type"] === "Invoice"
                    ) {
                        _row[columnkeyMap[key]] = services.money.format(
                            _row.total_amount
                        );
                    } else if (
                        key === "incomingAmount" &&
                        _row["document_type"] === "Credit"
                    ) {
                        _row[columnkeyMap[key]] = services.money.format(
                            _row.total_amount
                        );
                    } else if (key === "valor") {
                        _row["valor"] =
                            _row.trans_type === "CR"
                                ? _row.total_cr
                                : "-" + _row.total_dr;
                        _row[columnkeyMap[key]] = services.money.format(
                            _row["valor"]
                        );
                    } else if (key === "nifap") {
                        _row[columnkeyMap[key]] = _row.busEntidadeDetail.nifap;
                    } else if (key === "nome") {
                        if (_row.busEntidade) {
                            _row[columnkeyMap[key]] = _row.busEntidade[key];
                        } else {
                            _row[columnkeyMap[key]] =
                                _row.busEntidadeDetail.nome;
                        }
                        _row[columnkeyMap[key]] = _row[key];
                    } else if (key === "trans_date") {
                        _row[columnkeyMap[key]] = moment(
                            _row["trans_date"]
                        ).format(dateFormat);
                    } else if (key === "current_balance") {
                        _row[columnkeyMap[key]] = services.money.format(
                            _row["current_balance"]
                        );
                    } else if (key === "total_amount") {
                        _row[columnkeyMap[key]] = services.money.format(
                            _row["total_amount"]
                        );
                    } else if (key === "local") {
                        _row[columnkeyMap[key]] = _row["key"] || "";
                    } else if (key === "amount_paid") {
                        _row[columnkeyMap[key]] = services.money.format(
                            _row[key]
                        );
                    } else if (key === "trans_amount") {
                        _row[columnkeyMap[key]] = services.money.format(
                            _row["trans_amount"]
                        );
                    } else if (key === "balance") {
                        _row[columnkeyMap[key]] = services.money.format(
                            _row["balance"]
                        );
                    } else if (key === "tipoVasilha") {
                        _row[columnkeyMap[key]] = _row["tipoVasilha"];
                    } else if (key === "numeroVasilha") {
                        _row[columnkeyMap[key]] = String(_row["numeroVasilha"]);
                    } else if (key === "capacidadeComunicada") {
                        // console.log(
                        //     "comun value 800",
                        //     _row["capacidadeComunicada"]
                        // );
                        _row[columnkeyMap[key]] =
                            _row["capacidadeComunicada"] || "";
                    } else if (key === "ownerName") {
                        _row[columnkeyMap[key]] = _row["nome"];
                    } else if (key === "capacidadeAferida") {
                        // console.log(" value 800", _row["capacidadeAferida"]);
                        _row[columnkeyMap[key]] =
                            _row["capacidadeAferida"] || "";
                    } else if (key === "Observações") {
                        _row[columnkeyMap[key]] = _row["observacoes"];
                    } else if (key === "n_sivv") {
                        _row[columnkeyMap[key]] = _row["CodigoIVV"];
                    } else if (key === "Codigo_Entreposto_fiscal") {
                        _row[columnkeyMap[key]] = _row["codEntrFiscal"];
                    } else _row[columnkeyMap[key]] = _row[key];
                });
                if (_row.document_type === "Invoice") {
                    _row.document_type = "Movements";
                } else if (_row.document_type === "Credit") {
                    _row.document_type = "Crédito";
                }
            });

            this.setState(
                {
                    data: res,
                    filterData: res,
                    showSearchMsg: false,
                    totalcount: window.localStorage.getItem("table_total"),
                },
                () => {
                    this.createTabel();
                    if (this.props.modificaoDateShow) {
                        this.props.modificaoDateShow(dateArray);
                    }
                }
            );
        } else {
            this.setState({ showSearchMsg: true }, () => {
                if (this.props.modificaoDateShow) {
                    this.props.modificaoDateShow([]);
                }
            });
        }
    };

    /* Para carregar o componente da tabela e definir todas as colunas  */

    createTabel = () => {
        if (this.state.linkData && this.state.linkData.columnkeyMap) {
            let columnkeyMap = { ...this.state.linkData.columnkeyMap };
            let columnlist = Object.keys(columnkeyMap).map(function (key) {
                return { field: columnkeyMap[key], columnMenuType: "checkbox" };
            });
            let actionbuttons = this.state.linkData.actionbuttons;
            let telkikTable = (
                <TlkTable
                    date={new Date()}
                    generateDocument={this.state.linkData.generateDocument}
                    noDownloadButton={this.state.linkData.noDownloadButton}
                    DocumentGERFIP={this.state.linkData.DocumentGERFIP}
                    Importarbutton={this.state.linkData.Importarbutton}
                    actionColumnName={this.state.linkData.actionColumnName}
                    groupfield={this.state.linkData.groupfield}
                    modulename={this.state.linkData.modulename || "fordefault"}
                    notAction={this.state.linkData.notAction}
                    tlkState={this.state.tlkState}
                    deleteFunc={(id) => this.props.handleDelete(id)}
                    tableFilters={(filter) => this.tableFilters(filter)}
                    list={this.state.filterData}
                    actionbuttons={actionbuttons}
                    columnlist={columnlist}
                    ActionPerform={(action, id) =>
                        this.ActionPerform(action, id)
                    }
                />
            );
            this.setState({
                telkikTable: telkikTable,
            });
        }
    };

    /* Obter filtros aplicados na tabela para atualização dinâmica */
    tableFilters = (tlfilter) => {
        let customfilters = this.getAllFilter();
        let granelFilters = this.getAllGranel();
        let columnkeyMap = this.state.linkData.columnkeyMap;
        let tlkState = { ...tlfilter };
        let data = this.makeTlkFilters(tlfilter, columnkeyMap, customfilters);
        let linkData = { ...this.state.linkData };
        // console.log("linkData",tlkState);
        // console.log("NewFilters=",data );
        // linkData.Filters = data.Filters
        this.setState(
            {
                tlkState,
                linkData,
            },
            () => this.getListData(),
            () => this.getAllGranel()
        );
        // return data;
    };

    /* Alterações de filtro de tabela em formatos de API */
    makeTlkFilters = (tlkfilter, columnkeyMap, data) => {
        let tlkState;
        let inFilters = {};
        let columnkeyMaprev = {};
        for (var key in columnkeyMap) {
            columnkeyMaprev[columnkeyMap[key]] = key;
        }
        if (
            tlkfilter.filter &&
            tlkfilter.filter.filters &&
            tlkfilter.filter.filters.length > 0
        ) {
            let tkkey = "";
            let tkkeyvalues = [];
            tlkfilter.filter.filters.map((_row, i) => {
                tkkey = "";
                tkkeyvalues = [];
                let checkamount = [];
                if (_row.filters && _row.filters.length > 0) {
                    _row.filters.map((_srow, k) => {
                        tkkey = _srow.field;
                        checkamount = _srow.value.split(" ");
                        if (checkamount[1] && checkamount[1] === "€") {
                            checkamount[0] = checkamount[0].replace(".", "");
                            checkamount[0] = checkamount[0].replace(",", ".");
                            _srow.value = checkamount[0];
                        }
                        _srow.value = $.isNumeric(_srow.value)
                            ? Number(_srow.value)
                            : _srow.value;
                        tkkeyvalues.push(_srow.value);
                    });
                    tkkey = columnkeyMaprev[tkkey];
                    tkkey = tkkey.toLowerCase();
                    inFilters[tkkey] = tkkeyvalues;
                }
            });
        }
        let defaultRequest = listdefaultRequest;
        defaultRequest.Page = tlkfilter.skip
            ? tlkfilter.skip / tlkfilter.take + 1
            : 1;
        defaultRequest.PageSize = tlkfilter.take ? tlkfilter.take : 100;
        if (tlkfilter && tlkfilter.sort && tlkfilter.sort.length > 0) {
            defaultRequest.SortBy = columnkeyMaprev[tlkfilter.sort[0].field];
            defaultRequest.IsSortTypeDESC =
                tlkfilter.sort[0].dir === "asc" ? false : true;
        }
        // data.inFilters = inFilters;
        return data;
    };

    /*  Para realizar a ação com base na seleção da tabela  */

    ActionPerform = (action, row) => {
        if (this.props.ActionPerform) {
            this.props.ActionPerform(action, row);
        } else {
            let popUpForm = null;
        }
    };

    /*  Para renderizar o conteúdo html da página   */

    render() {
        return (
            <div className="table-responsive table-section">
                {
                    //uncomment this ************************************************************
                    this.props.tableName == "Instalações" &&
                        this.state.telkikTable && (
                            <>
                                <h3>
                                    {" "}
                                    A pesquisa retornou {
                                        this.state.totalcount
                                    }{" "}
                                    resultados{" "}
                                </h3>
                                {this.state.telkikTable}
                            </>
                        )
                }

                {
                    //uncomment this ************************************************************
                    this.props.tableName == "Instalações_Vasilhas" &&
                        this.state.telkikTable &&
                        this.props.isInEdit && (
                            <>
                                <h3>
                                    {" "}
                                    A pesquisa retornou{" "}
                                    {Array.isArray(this.props.allVasilha) &&
                                        this.props.allVasilha.length}{" "}
                                    resultados{" "}
                                </h3>
                                {this.state.telkikTable}
                            </>
                        )
                }

                {this.props.tableName === "Instalações_Vasilhas" &&
                    this.state.totalcount === 0 && (
                        <div className="searct-found">
                            <img
                                className="img-fluid"
                                src="imgs/data-instalacoesvinicas.png"
                                alt=""
                            />
                            {this.state.showSearchMsg ? (
                                <p className="font-14">Sem resultados</p>
                            ) : (
                                <h3>
                                    Pesquise uma instalação ou entidade para
                                    apresentação de mais informações
                                </h3>
                            )}
                        </div>
                    )}
                {this.props.tableName === "Instalações" &&
                    this.state.totalcount === 0 && (
                        <div className="searct-found">
                            <img
                                className="img-fluid"
                                src="imgs/data-instalacoesvinicas.png"
                                alt=""
                            />
                            {this.state.showSearchMsg ? (
                                <p className="font-14">Sem resultados</p>
                            ) : (
                                <h3>
                                    Pesquise uma instalação ou entidade para
                                    apresentação de mais informações
                                </h3>
                            )}
                        </div>
                    )}
            </div>
        );
    }
}

export default InstalaCaovinicaTables;
